import { render, staticRenderFns } from "./DocumentosCandidato.vue?vue&type=template&id=207406a6&scoped=true"
import script from "./DocumentosCandidato.vue?vue&type=script&lang=js"
export * from "./DocumentosCandidato.vue?vue&type=script&lang=js"
import style0 from "./DocumentosCandidato.vue?vue&type=style&index=0&id=207406a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207406a6",
  null
  
)

export default component.exports